<div class="container">
    <div class="headerError">
        <img class="colissimoLogo" src="assets/images/Colissimo_Logo.svg">
    </div>

    <div class="container_oups">
        <div class="oups"> {{"error.oops" | translate}}</div>
        <div class="label" *ngIf="errorMessage != ''">{{errorMessage}}</div>
        <div class="label" *ngIf="errorMessage == ''">{{"error.invalid" |translate}}</div>
    </div>
</div>
<app-footer class="footer"></app-footer>